import Link from "next/link";
import AddEvent from "../Event/AddEvent";
import OwnImage from "@ui/components/ui/event/OwnImage";
import SocialMedia from "./SocialMedia";

const FooterMobile = () => {
  return (
    <div className="flex w-full flex-col items-center justify-between px-4 py-10">
      <div className="flex h-[32px] w-full justify-center">
        <OwnImage
          src="/images/logos/logo_connect_events_horizontale.png"
          alt="logo avec nom Connect'Events"
          className="static h-9 w-auto p-1"
          width={880}
          height={200}
        />
      </div>
      <Link href="https://www.bourgognefranchecomte.fr" target="_blank">
        <div className="relative mt-8 aspect-[14.5/11.6] h-[20mm] min-h-[11.6mm] min-w-[14.5mm]">
          <OwnImage
            src="/images/logos/region_bfc.jpg"
            alt="logo"
            className="object-scale-down"
          />
        </div>
      </Link>
      <div className="flex flex-col justify-between pt-4">
        <p className="pb-2 text-base font-semibold text-gray-700">
          Rejoignez-nous sur
        </p>
        <div className="flex flex-row justify-center gap-4">
          <SocialMedia
            svgName="instagram_logo"
            url="https://www.instagram.com/connect_events_off"
          />
          <SocialMedia
            svgName="facebook_logo"
            url="https://www.facebook.com/people/ConnectEvents/61576724692750"
          />
          <SocialMedia
            svgName="linkedin_logo"
            url="https://www.linkedin.com/company/acexpo-connectevents/posts/?feedView=all"
          />
        </div>
      </div>
      <div className="flex w-full flex-col justify-center gap-6 pt-8 text-center text-base font-semibold text-primary-600">
        <Link href={"/"}>Découvrir</Link>
        <AddEvent className="text-base" />
        <Link href={"/profile/faq"}>FAQ</Link>
        <Link href={"/profile/help"}>Aide</Link>
      </div>
      <div className="flex flex-col items-center pt-8 text-center text-xs text-gray-700">
        <div className="flex flex-col gap-4 text-center">
          <Link href="/cgu" target="_blank">
            CGU
          </Link>
          <Link href="/cgv" target="_blank">
            CGV
          </Link>
          <Link href="/politique-de-confidentialite" target="_blank">
            Politique de confidentialité
          </Link>
          <Link href="/mentions-legales" target="_blank">
            Mentions légales
          </Link>
        </div>
        <p className="pt-8 text-gray-500">© Connect&apos;Events</p>
      </div>
    </div>
  );
};

export default FooterMobile;
